import React, { Component } from "react";
import {
    Container,
    Form,
    Button,
    Message
} from "semantic-ui-react";
import Validator from "validatorjs";
import set from "lodash/set";
import request from "../../utils/request";
import UploadImageForm from "../../components/content/UploadImageForm";
import ModalUpload from '../../components/forms/upload/ModalUpload'
import { apiUrl } from "../../utils/constants";

const beneficiaryProfile = () => {
    return {
        id: 0,
        name: "",
        file: null,
        preview: null
    };
};

const resetState = (cls) => {
    return {
        isMounted: false,
        isLoading: true,
        xhrStatus: "",
        xhrMessage: "",
        validation: new Validator({}, {}),
        beneficiaryId: 0,
        profile: beneficiaryProfile(),
        needsUploading: false,
        needsSaving: false,
        isSaving: false,
    };
};

class BeneficiaryForm extends Component {
    constructor(props) {
        super(props);
        this.rules = {};
        this.customMessages = {};
        this.state = resetState(this);
        let id = this.props.match.params.id ? this.props.match.params.id : 0;
        this.state.beneficiaryId = id;

        this.handleChange = this.handleChange.bind(this);
        this.fetchData = this.fetchData.bind(this);

        this.getUploadParams = this.getUploadParams.bind(this);
        this.handleFileUploadsComplete = this.handleFileUploadsComplete.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    componentDidMount = () => {
        if (this.props.match.params.id === ":id") {
            this.props.history.replace('/beneficiaries');
            return;
        }
        this.setState({ isMounted: true }, this.fetchData);
    };
    componentWillUnmount = () => {
        this.setState(resetState(this));
    };
    fetchData = () => {
        let self = this;
        let promises = [];
        if (this.state.beneficiaryId > 0) {
            promises.push(
                request.get(this, `api:/beneficiary/${this.state.beneficiaryId}`, {ts: Date.now()})
            );
        }
        Promise.all(promises).then(function (values) {
            if (values[0]) {
                self.setProfile(values[0]);
            }
            self.setState({ isLoading: false });
        });
    };
    handleChange = (e, { name, value }) => {
        let data = this.state.profile;
        set(data, name, value);
        this.setState({ profile: data, needsSaving: true });
    };
    setProfile = result => {
        let profile = result;
        profile.preview = result.logo_url;
        this.setState({
            profile: profile,
            isLoading: false
        });
    };
    handleSubmit = () => {
        let req;
        this.setState({
            isLoading: true,
            xhrStatus: "",
            xhrMessage: ""
        });
        const { profile } = this.state;
        let formData = new FormData();
        formData.append("name", profile.name);
        if (profile.id > 0) {
            req = request.post(this, `api:/beneficiary/${profile.id}?_method=PUT`, formData);
        } else {
            req = request.post(this, "api:/beneficiary", formData);
        }
        req.then(resp => {
            this.setState({
                xhrStatus: resp.success === true ? "success" : "error",
                xhrMessage: resp.message,
                isLoading: false
            });
            if (resp.status === "success" && this.state.beneficiaryId === 0) {
                this.setState({ profile: beneficiaryProfile() });
            }
        })
    };
    handleDrop = (i, file) => {
        if (!file) {
            return;
        }
        const { profile } = this.state
        profile.file = file;
        profile.preview = URL.createObjectURL(file);
        this.setState(prevState => ({
            profile: profile,
            needsUploading: true,
            needsSaving: true
        }));
    };
    getUploadParams = ({ file, meta }) => {
        const { profile } = this.state;
        let formData = new FormData()
        formData.append('file', file)
        formData.append("name", profile.name);
        let url = "";
        const headers = {
            "Authorization": "Bearer " + this.getCookie('accessToken'),
        }
        if (profile.id > 0) {
            url = (apiUrl() + '/beneficiary/' + profile.id +'?_method=PUT');
        } else {
            url = (apiUrl() + `/beneficiary`);

        }
        return {
            url: url,
            body: formData,
            headers: headers,
        }
    }
    getCookie = name => {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2)
            return parts
                .pop()
                .split(";")
                .shift();
    };
    handleFileUploadsComplete = (response) => {
    }
    closeModal = (status, error, fileWithMeta) => {
        if (fileWithMeta[0]) {
            const file = fileWithMeta[0];
            const response = JSON.parse(file.xhr.response)
            this.setState({
                xhrStatus: response.success === true ? "success" : "error",
                xhrMessage: response.message,
                isLoading: false
            });
            return;
        }
        if ((error && error !== "") || status === false) {
            this.setState({
                isSaving: false,
            });
            return;
        }
        this.setState({
            isSaving: false,
        });
    }
    deleteElement = (i, file) => {
        const { profile } = this.state;
        profile.file = ""
        profile.preview = ""

        this.setState({ profile: profile, needsSaving: true });
    }
    handleRules = (obj, msg = {}) => {
        this.rules = obj;
        this.customMessages = msg;
      };
    handleSave = async () => {
        const { needsUploading, profile } = this.state;
        this.setState({
            isSaving: true
        });
        if (!needsUploading) {
            // code block for validation
            let validation = new Validator(profile, this.rules, this.customMessages);
            this.setState({ validation });
            if (validation.passes()) {
                this.handleSubmit();
            }
        }
    }
    render() {
        const {
            isLoading,
            xhrStatus,
            xhrMessage,
            profile,
            needsSaving,
            needsUploading,
            isSaving,
            validation
        } = this.state;

        const rules = {
            "name": "required"
        };
        const customMessages = {
            "required.name": "Name is required"
        };
        this.handleRules(rules, customMessages);

        const files = [];
        files.push(profile.file);
        return (
            <Container text>
                <ModalUpload
                    getUploadParams={this.getUploadParams}
                    files={files}
                    handleFileUploadsComplete={this.handleFileUploadsComplete}
                    openModal={isSaving && needsUploading}
                    closeModal={this.closeModal}
                />
                <Message negative hidden={!(xhrStatus !== "" && xhrStatus === "error")}>
                    <p>{xhrMessage}</p>
                </Message>
                <Message
                    positive
                    hidden={!(xhrStatus !== "" && xhrStatus === "success")}
                >
                    <p>{xhrMessage}</p>
                </Message>
                <Form
                    loading={isLoading}
                    success={xhrStatus === "success"}
                    error={xhrStatus === "error" || (validation && validation.errorCount > 0)}
                >
                    {validation.errorCount > 0 && <Message
                        error
                        content={Object.keys(validation.errors.all()).map((item, key) => {
                            return (
                            <span key={key}>
                                {validation.errors.first(item)}
                                <br />
                            </span>
                            );
                        })}
                    />}
                    <Form.Input
                        fluid
                        name="name"
                        label="Name of Beneficiary"
                        placeholder="Name of Beneficiary"
                        value={profile.name}
                        onChange={this.handleChange}
                        required
                        error={validation.errors.has("name")}
                    />
                    <UploadImageForm
                        backgroundImage={profile.preview}
                        id="beneficiary_logo"
                        handleDrop={this.handleDrop}
                        handleDelete={this.deleteElement}
                        accept="image/*"
                    />
                    {needsSaving && (profile && profile.name !== "") && (<div className="pt-4">
                        <Button
                            fluid
                            icon="save"
                            content="Save"
                            primary
                            onClick={this.handleSave}
                        />
                    </div>
                    )}
                </Form>
            </Container>
        );
    }
}

export default BeneficiaryForm;
